import React, { useEffect, useState } from "react";
import { ConfigProvider } from "antd";
import en_US from "antd/locale/en_US";
import ru_RU from "antd/locale/ru_RU";
import uz_UZ from "antd/locale/uz_UZ";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/uz";
import i18n from "../locale/i18n/i18n";

const ANTD_LOCALES: Record<string, typeof en_US> = {
  en: en_US,
  ru: ru_RU,
  uz: uz_UZ,
};

const baseLanguage = (language?: string) =>
  (language ?? "uz").slice(0, 2).toLowerCase();

dayjs.locale(baseLanguage(i18n.language));

/** Keeps antd and dayjs locales in sync with the language chosen in i18n. */
const AntdLocaleProvider = ({ children }: { children: React.ReactNode }) => {
  const [language, setLanguage] = useState(() => baseLanguage(i18n.language));

  useEffect(() => {
    const handleLanguageChange = (next: string) =>
      setLanguage(baseLanguage(next));
    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    dayjs.locale(language);
  }, [language]);

  return (
    <ConfigProvider locale={ANTD_LOCALES[language] ?? uz_UZ}>
      {children}
    </ConfigProvider>
  );
};

export default AntdLocaleProvider;
